import { render, staticRenderFns } from "./PeriodicPaymentTemplates.vue?vue&type=template&id=9a09eb96&scoped=true"
import script from "./PeriodicPaymentTemplates.vue?vue&type=script&lang=js"
export * from "./PeriodicPaymentTemplates.vue?vue&type=script&lang=js"
import style0 from "./PeriodicPaymentTemplates.vue?vue&type=style&index=0&id=9a09eb96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a09eb96",
  null
  
)

export default component.exports